import { Text, View } from '@react-pdf/renderer'
import { FC } from 'react'
import { pdfStyles } from './pdfStyles'

export const TableRow1: FC<{ col1: string; col2?: string }> = ({ col1, col2 }) => {
  return (
    <View style={pdfStyles.tableRow}>
      <View style={{ ...pdfStyles.tableColumn, ...pdfStyles.tableColumnTitle }}>
        <Text>{col1}</Text>
      </View>
      <View style={{ ...pdfStyles.tableColumn, width: '80%' }}>
        <Text>{col2}</Text>
      </View>
    </View>
  )
}
